import { Link } from '@/router';
import { GonjongMark } from '@/components/Motifs';

export default function NotFound() {
  return (
    <div className="mx-auto max-w-6xl px-4 py-24 sm:px-6 md:py-32" data-testid="not-found-page">
      <GonjongMark className="h-16 w-16 text-turmeric" />
      <h1 className="mt-8 font-display text-4xl font-bold tracking-tight text-charcoal sm:text-5xl">
        Halaman Tidak Ditemukan
      </h1>
      <p className="mt-5 max-w-xl text-base leading-relaxed text-stone-600 sm:text-lg">
        Maaf, halaman yang Anda cari tidak tersedia atau telah dipindahkan. Silakan kembali ke
        beranda atau jelajahi daftar hidangan kami.
      </p>
      <div className="mt-10 flex flex-wrap gap-4">
        <Link
          to="/"
          data-testid="notfound-cta-home"
          className="inline-flex items-center rounded-full bg-crimson px-7 py-3.5 text-sm font-bold text-santan transition-colors duration-200 hover:bg-crimson-dark"
        >
          Kembali ke Beranda
        </Link>
        <Link
          to="/menu/"
          data-testid="notfound-cta-menu"
          className="inline-flex items-center rounded-full border-2 border-charcoal/15 px-7 py-3 text-sm font-bold text-charcoal transition-colors duration-200 hover:border-turmeric hover:text-crimson"
        >
          Lihat Daftar Hidangan
        </Link>
      </div>
    </div>
  );
}
